module.exports = "/fonts/vendor/material-icons/iconmaterial-icons-sharp.woff?3a4004a46a653d4b2166dd7273dd24bb";